var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('EditorEditProjectItem'),_c('v-card-actions',[_c('v-btn',{attrs:{"block":"","color":"secondary","loading":_vm.projectProcessing},on:{"click":_vm.handleSaveButton}},[_vm._v("save")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }